import React, { Component } from "react";
import Horizontal from "./horizontal";

class HorizontalSliderComponent extends Component {
  constructor(props) {
    super(props);
  }

  componentDidCatch(error) {
    /* eslint-disable-next-line */
    console.log(error);
  }

  render() {
    return (
      <div>
        <Horizontal api={this.props} />
      </div>
    );
  }
}

export default HorizontalSliderComponent;
